import { VariantBoundary } from "./VariantBoundary.js";
import { VariantRange } from "./VariantRange.js";
const getConjunction = (x, y, compareValues) => {
  if (!x || !y) {
    throw new Error("VariantRange cannot be null");
  }
  const lessThan = getExtremeValue(x.lessThan, y.lessThan, false, compareValues);
  const greaterThan = getExtremeValue(x.greaterThan, y.greaterThan, true, compareValues);
  if (lessThan != null && greaterThan != null) {
    const comp = VariantBoundary.compareValues(lessThan.value, greaterThan.value, compareValues);
    if (comp < 0) {
      return null;
    } else if (comp === 0 && (!lessThan.isClosed || !greaterThan.isClosed)) {
      return null;
    }
  }
  return VariantRange.create({ lessThan, greaterThan });
};
const getExtremeValue = (x, y, max, compareValues) => {
  if (x === null) {
    return y;
  }
  if (y === null) {
    return x;
  }
  const comp = VariantBoundary.compareValues(x.value, y.value, compareValues);
  if (comp > 0 || comp === 0 && x.isClosed) {
    return max ? x : y;
  }
  return max ? y : x;
};
const getDisjunction = (x, y, compareValues) => {
  if (!x || !y) {
    throw new Error("VariantRange cannot be null");
  }
  if (x === y) {
    return x;
  }
  if (x === VariantRange.Everything || y === VariantRange.Everything) {
    return VariantRange.Everything;
  }
  if (cannotOverlap(y.greaterThan, x.lessThan, compareValues) || cannotOverlap(x.greaterThan, y.lessThan, compareValues)) {
    return null;
  }
  const lessThan = getExtremeBoundary(x.lessThan, y.lessThan, true, compareValues);
  const greaterThan = getExtremeBoundary(x.greaterThan, y.greaterThan, false, compareValues);
  return VariantRange.create({ lessThan, greaterThan });
};
const cannotOverlap = (x, y, compareValues) => {
  if (x == null || y == null) {
    return false;
  }
  const comp = VariantBoundary.compareValues(x.value, y.value, compareValues);
  if (comp > 0 || comp === 0 && !x.isClosed && !y.isClosed) {
    return true;
  }
  return false;
};
const getExtremeBoundary = (x, y, max, compareValues) => {
  if (x == null || y == null) {
    return null;
  }
  const comp = VariantBoundary.compareValues(x.value, y.value, compareValues);
  if (max ? comp > 0 : comp < 0) {
    return x;
  } else if (comp === 0) {
    return x.isClosed ? x : y;
  } else {
    return y;
  }
};
export {
  cannotOverlap,
  getConjunction,
  getDisjunction,
  getExtremeBoundary,
  getExtremeValue
};
//# sourceMappingURL=VariantRange.utils.js.map
